import dayjs, { Dayjs } from "dayjs";

import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "America/New_York";

export interface Banner {
  key: string;
  description: React.ReactNode;
  starts_at?: Dayjs;
  ends_at: Dayjs;
}

export const BANNERS: Banner[] = [
  {
    key: "launchsale",
    description: (
      <span className="text-center">
        <span className="t7">Launch week special!</span> Use code WELCOME for
        10% off all products until December 2.
      </span>
    ),
    ends_at: dayjs.tz("2024-12-02 23:59:59", TZ),
  },
  {
    key: "shipping_pause_dec_2024",
    description: (
      <span className="text-center">
        <span className="t7">Shipping is currently paused.</span> Next shipment
        will go out on December 26th!
      </span>
    ),
    ends_at: dayjs.tz("2024-12-23 23:59:59", TZ),
  },
  {
    key: "shipping_pause_may_2025",
    description: (
      <span className="text-center">
        <span className="t7">Shipping is currently paused.</span> Next shipment
        will go out on May 20th; all orders before then receive free shipping
        with code <span className="t7">MAYTRAVEL2025</span>.
      </span>
    ),
    ends_at: dayjs.tz("2025-05-19 23:59:59", TZ),
  },
  {
    key: "shipping_pause_nov_2025",
    description: (
      <span className="text-center">
        <span className="t7">Shipping is currently paused.</span> Next shipment
        will go out on November 21st.
      </span>
    ),
    ends_at: dayjs.tz("2025-11-18 23:59:59", TZ),
  },
];

export const getActiveBanners = (): Banner[] => {
  const now = dayjs();
  return BANNERS.filter((banner) => {
    return (
      (!banner.starts_at || banner.starts_at.isBefore(now)) &&
      banner.ends_at.isAfter(now)
    );
  });
};
